"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _isArray2 = _interopRequireDefault(require("lodash/fp/isArray"));

var _isFunction2 = _interopRequireDefault(require("lodash/fp/isFunction"));

var _universalRouter = _interopRequireDefault(require("universal-router"));

var _selectors = require("./selectors");

var _url = require("./url");

var _feature = require("./actions/feature");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var convertRoute = function (route) {
  return route && route.load ? __assign(__assign({}, route), {
    children: []
  }) : route;
};

var _default = function _default(_a) {
  var routes = _a.routes,
      auth = _a.auth,
      _b = _a.baseUrl,
      baseUrl = _b === void 0 ? '' : _b,
      options = __rest(_a, ["routes", "auth", "baseUrl"]);

  return new _universalRouter.default((0, _map2.default)(convertRoute)(routes), __assign(__assign({}, options), {
    baseUrl: baseUrl === '/' ? '' : baseUrl,
    resolveRoute: function (context, params) {
      return __awaiter(this, void 0, void 0, function () {
        var route, _a, dispatch, getState, load, action, onEnter, feature, requireAuth, component, redirect, state, authResult, module_1, result, result;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              route = context.route, _a = context.store, dispatch = _a.dispatch, getState = _a.getState;
              load = route.load, action = route.action, onEnter = route.onEnter, feature = route.feature, requireAuth = route.requireAuth, component = route.component, redirect = route.redirect;
              state = getState();
              if (!onEnter) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , onEnter(context)];

            case 1:
              _b.sent();

              _b.label = 2;

            case 2:
              if (feature) {
                dispatch((0, _feature.setFeature)(feature));
              }

              if (auth) {
                authResult = auth({
                  requireAuth: requireAuth,
                  state: state
                });

                if (authResult) {
                  return [2
                  /*return*/
                  , authResult];
                }
              } else if (requireAuth && !(0, _selectors.getEntity)('auth.isLogin')(state)) {
                return [2
                /*return*/
                , {
                  redirect: (0, _url.getWithBaseUrl)('/auth/login', baseUrl)
                }];
              }

              if (redirect || redirect === '') {
                return [2
                /*return*/
                , __assign(__assign({}, route), {
                  redirect: (0, _url.getWithBaseUrl)(redirect, baseUrl)
                })];
              }

              if (component) {
                return [2
                /*return*/
                , route];
              }

              if (!(0, _isFunction2.default)(load)) return [3
              /*break*/
              , 5];
              return [4
              /*yield*/
              , load()];

            case 3:
              module_1 = _b.sent();
              return [4
              /*yield*/
              , module_1.default(context, params)];

            case 4:
              result = _b.sent();

              if ((0, _isArray2.default)(result)) {
                route.children = (0, _map2.default)(convertRoute)(result);
              } else if (result.component) {
                return [2
                /*return*/
                , result];
              } else {
                route.children = [convertRoute(result)];
              }

              _b.label = 5;

            case 5:
              if (!(0, _isFunction2.default)(action)) return [3
              /*break*/
              , 7];
              return [4
              /*yield*/
              , action(context, params)];

            case 6:
              result = _b.sent();

              if (result.feature) {
                dispatch((0, _feature.setFeature)(result.feature));
              }

              if (result.redirect || result.redirect === '') {
                result.redirect = (0, _url.getWithBaseUrl)(result.redirect, baseUrl);
              }

              return [2
              /*return*/
              , __assign(__assign({}, context.route), result)];

            case 7:
              return [2
              /*return*/
              , context.next()];
          }
        });
      });
    }
  }));
};

exports.default = _default;